// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eff748fa","455":"735511f8","977":"d2c4dfe1"}[chunkId] + ".chunk.js";
};